<template>
  <div v-if="!seriesPreselected">
    <div class="styled-radio-container--ou-donation type-selector">
      <!-- <div class="radio-part">
      <input id="type_shiur" type="radio" :checked="getValue('custom.sponsorshipType') == 'shiur'" @click="setValue('custom.sponsorshipType', 'shiur')" >
      <FormLabel for="type_shiur">
        shiur old Hayom
      </FormLabel>
    </div>  -->
      <div class="radio-part">
        <input
          id="type_daily"
          type="radio"
          :checked="getValue('custom.sponsorshipType') == 'daily'"
          @click="setValue('custom.sponsorshipType', 'daily')"
        />
        <FormLabel for="type_daily"> Parnes Hayom </FormLabel>
      </div>
      <div class="radio-part">
        <input
          id="type_weekly"
          type="radio"
          :checked="getValue('custom.sponsorshipType') == 'weekly'"
          @click="setValue('custom.sponsorshipType', 'weekly')"
        />
        <FormLabel for="type_weekly"> Parnes Hashavua </FormLabel>
      </div>
      <div class="radio-part">
        <input
          id="type_gen"
          type="radio"
          :checked="getValue('custom.sponsorshipType') == 'general'"
          @click="setValue('custom.sponsorshipType', 'general')"
        />
        <FormLabel for="type_gen"> General Donation </FormLabel>
      </div>
    </div>
    <ErrorLabel field="custom.sponsorshipType" />
    <hr />

    <!-- old daily shiur -->
    <!-- <div class="donation-type" v-if="getValue('custom.sponsorshipType') == 'shiur'">
    <div style="margin-bottom: 20px;">                    
      <FormLabel>
          <input type="radio" name="donationShiurType" id="donationShiurType-shiur" :checked="donationShiurType == 'shiur'" @click="()=>{donationShiurType = 'shiur'}"> Sponsor a general shiur (Audio/ Video/ Text) - <b><MoneyFormat class="label-amount" :value="180" :currencyCode="form.currency || 'USD'" :hide-subunits="true" /></b>
      </FormLabel>
      <br/><br/>
      <FormLabel>
          <input type="radio" name="donationShiurType" id="donationShiurType-alya" :checked="donationShiurType == 'alya'" @click="()=>{donationShiurType = 'alya'}"> Sponsor an Aliya Yomi shiur (Daily shiurim every week) - <b><MoneyFormat class="label-amount" :value="360" :currencyCode="form.currency || 'USD'" :hide-subunits="true" /></b>
      </FormLabel>                   
    </div>
    <template v-if="donationShiurType == 'shiur'">
    <FormRow inline>
      <FormSelect field="custom.programId" style="flex:1;margin-right:10px">
        <option :value="null">Select a Shiur</option>
        <option v-for="shiur of shiurim" :key="shiur.id" :value="shiur.id">{{shiur.name}}</option>
      </FormSelect>      
      <DatePicker v-model="shiurWeekDate" v-bind="datepickerOptions" placeholder="Select start date"/>
    </FormRow>
    <ErrorLabel field="custom.startDate" />
    <ErrorLabel field="custom.programId" />
   </template> 

    <template v-if="donationShiurType == 'alya'">
    <FormRow inline>
      <FormSelect field="custom.programId"  style="flex:1;margin-right:10px">
        <option :value="null">Select Aliya Yomi</option>
        <option v-for="shiur of yomis" :key="shiur.id" :value="shiur.id">{{shiur.name}}</option>
      </FormSelect>
      <DatePicker v-model="alyaWeekDate" v-bind="datepickerOptions" placeholder="Select start date"/>
    </FormRow>

    <ErrorLabel field="custom.programId" />

    <ErrorLabel field="custom.startDate" />
    </template>
  </div> -->

    <!-- daily -->
    <div class="donation-type" v-if="getValue('custom.sponsorshipType') == 'daily'">
      <FormRow inline style="max-width: 50%; margin-bottom: 10px">
        <input
          type="date"
          class="date-input"
          @change="setDailyDate(new Date($event.target.value))"
        />
      </FormRow>
      <div>
        <FormLabel
          >Dedicate a day of learning across the platform.<br />(Dedication will be
          displayed across all series) -
          <b
            ><MoneyFormat
              class="label-amount"
              :value="180"
              :currencyCode="form.currency || 'USD'"
              :hide-subunits="true" /></b
        ></FormLabel>
      </div>

      <div><ErrorLabel field="custom.startDate" /></div>
      <div style="margin-bottom: 20px">
        <FormLabel
          >For naming and other special dedications please contact
          <a href="mailto:info@allparsha.org">info@allparsha.org</a></FormLabel
        >
      </div>
    </div>

    <!-- weekly -->
    <div class="donation-type" v-if="getValue('custom.sponsorshipType') == 'weekly'">
      <FormRow inline style="max-width: 50%; margin-bottom: 10px">
        <input
          type="date"
          class="date-input"
          @change="setDate(new Date($event.target.value))"
        />
      </FormRow>
      <div>
        <FormLabel
          >Dedicate a week of learning across the platform.<br />(Dedication will be
          displayed across all series) -
          <b
            ><MoneyFormat
              class="label-amount"
              :value="1000"
              :currencyCode="form.currency || 'USD'"
              :hide-subunits="true" /></b
        ></FormLabel>
      </div>
      <div><ErrorLabel field="custom.startDate" /></div>
      <div style="margin-bottom: 20px">
        <FormLabel
          >For naming and other special dedications please contact
          <a href="mailto:info@allparsha.org">info@allparsha.org</a></FormLabel
        >
      </div>
    </div>

    <!-- general -->
    <div
      class="donation-type general"
      v-if="getValue('custom.sponsorshipType') == 'general'"
    >
        <AmountSelector defaultCheckedAount="360"/>
      <br />
              <div class="alltorah__honor">* Join the All Torah, All Year 360 Scroll of Honor</div>
    </div>
  </div>
  <div v-else>
    <h1 class="sponsor"><span>Sponsor Series</span>{{ selectedSeries }}</h1>
    <div class="donation-type general">
      <div class="note">$180 donation and above entitles you to a Shiur dedication</div>
      <AmountSelector />
      <FormRow inline style="max-width: 50%" v-if="showDedicationAndDate">
        <input
          type="date"
          class="date-input"
          @change="setDate(new Date($event.target.value))"
        />
      </FormRow>

      <ErrorLabel field="custom.startDate" />
    </div>
  </div>
</template>
<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  ref,
  watch,
} from "vue";
import { usePaymentForm } from "~/shared/use-payment-form";

export default defineComponent({
  props: {
    seriesPreselected: Boolean,
    showDedicationAndDate: Boolean,
  },
  setup() {
    const { setValue, getValue, form } = usePaymentForm();

    const shiurim = ref([]);
    const yomis = ref([]);

    const donationShiurType = ref<string | null>(null);
    setValue("amount", "360");
  setValue("custom.sponsorshipType", 'general');

    watch(
      () => getValue("custom.sponsorshipType"),
      () => {
        if (getValue("custom.sponsorshipType") == "weekly") {
          setValue("amount", "1000");
        } else if (getValue("custom.sponsorshipType") == "daily") {
          setValue("amount", "180");
        } else {
          setValue("amount", null);
        }

        setValue("custom.programId", null);

        donationShiurType.value = null;

        if (getValue("custom.sponsorshipType") == "general") {
          setValue("custom.startDate", null);
          setValue("custom.endDate", null);
        }
      }
    );

    watch(donationShiurType, () => {
      setValue("custom.programId", null);

      if (donationShiurType.value == "alya") {
        setValue("amount", "360");
      }
      if (donationShiurType.value == "shiur") {
        setValue("amount", "180");
      }
    });

    const selectedSeries = computed(() => {
      //@ts-ignore
      const foundSeries = shiurim.value.find((x) => x.id == getValue("custom.programId"));
      //@ts-ignore
      const foundYomi = yomis.value.find((x) => x.id == getValue("custom.programId"));

      //@ts-ignore
      if (foundSeries) return foundSeries.name;

      //@ts-ignore
      if (foundYomi) return foundYomi.name;

      return null;
    });

    watch(selectedSeries, (selectedSeries) => {
      setValue("applications.0.subCampaign", selectedSeries);
    });

    onMounted(() => {
      fetch(
        process.env.NODE_ENV == "production"
          ? "https://outorah.org/allParshaSeries"
          : "https://outorah.oudev.org/allParshaSeries"
      )
        .then((x) => x.json())
        .then((x) => {
          // Prod returns allParshaType with underscores ("Aliya_Yomi"),
          // staging with spaces ("Aliya Yomi"); normalize before filtering.
          x = x.map((item: any) => ({
            ...item,
            allParshaType: (item.allParshaType || "").replace(/_/g, " "),
          }));
          shiurim.value = x.filter((x: any) => x.allParshaType != "");
          yomis.value = x.filter((x: any) => x.allParshaType == "Aliya Yomi");
        });
    });

    function setDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 6)
        ).toISOString()
      );
    }

    function setDailyDate(date: Date) {
      setValue(
        "custom.startDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate())
        ).toISOString()
      );
      setValue(
        "custom.endDate",
        new Date(
          Date.UTC(date.getFullYear(), date.getMonth(), date.getDate() + 1)
        ).toISOString()
      );
    }

    return {
      donationShiurType,
      shiurim,
      form,
      yomis,
      currency: computed(() => form.value.currency),
      getValue,
      setValue,
      setDate,
      setDailyDate,
      selectedSeries,
    };
  },
});
</script>
<style scoped lang="scss">
.styled-radio-container--ou-donation {
  margin: 0 0 5px 0px;
  display: flex;
  flex-wrap: wrap;
  width: 100%;

  .radio-part {
    padding: 0px 5px;
    line-height: 1;
    @media (max-width: 720px) {
      width: 50%;
      margin-bottom: 10px;
    }
    @media (min-width: 720px) {
      min-width: 33.33333%;
      flex: 1;
      padding-left: 0;
      max-width: 33.33333%;
      margin-bottom: 10px;

      &:nth-child(6n) {
        padding-right: 0;
      }
    }
  }
  input[type="radio"] {
    height: 0;
    top: 20px;
    position: relative;
    left: 20px;
    z-index: -1;
    visibility: hidden;
  }
  label {
    padding: 15px;
    background: #fff;
    border: 1px solid #93a9c1;
    color: #2e343c;
    width: 100%;
    text-align: center;
    border-radius: 4px;
    cursor: pointer;
    margin-top: -15px;
    display: block;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  input[type="radio"]:checked + label {
    background: #99badd;
    color: #ffffff;
  }
  label:hover {
    background: #e9f0f7;
  }
  .amount_other__wrapper {
    input[type="number"] {
      background: #fff;
      margin-top: -15px;
    }
  }
}

//type selector
.type-selector {
  .radio-part {
    min-width: 33.333%;
    max-width: 33.333%;
    text-transform: uppercase;
    font-size: 13px;
  }
}

//amount selector
.donation-type.general {
  ::v-deep .styled-radio--ou-donation.styled-radio {
    label {
      border: 1px solid #93a9c1;
      color: #2e343c;
      font-weight: normal;
    }
    input[type="radio"]:checked + label {
      background: #99badd;
      color: #ffffff;
    }
  }
}
hr {
  margin-bottom: 20px;
}
::v-deep .money_format {
  display: inline;
}

h1.sponsor {
  margin-bottom: 20px;
  padding-bottom: 20px;
  border-bottom: 1px solid #efefef;
  letter-spacing: -1px;
  font-size: 28px;
  line-height: 1.4;
  margin-top: 20px;
  span {
    display: block;
    font-size: 14px;
    text-transform: uppercase;
    color: #999;
  }
}
.note {
  margin-bottom: 15px;
  background: #348dff1a;
  padding: 8px 12px;
  border-radius: 4px;
  font-size: 14px;
  border: 1px solid #d8e2ec;
}
label {
  line-height: 1.4;
}
.date-input {
  width: 100%;
  padding: 8px 12px;
  font-size: 14px;
  border: 1px solid #ccc;
  border-radius: 4px;
  color: #222;
}
  ::v-deep
.styled-radio.styled-radio--ou-donation.row 
  input[type="radio"]
  + label[data-amount="360"] {
  &:after {
    content: "*";
    font-size: 11px;
    padding-left: 2px;
  }
}

.alltorah__honor{
  font-size: 14px;
  padding-bottom: 15px;
}
</style>
